<template>
<v-row :justify="justify">
  <v-col v-if="enterpriseId && (enterprise.type || enterprise.payroll === 1)" cols="12" xl="4">
    <v-navigation-drawer
      width="100%"
      :value="true"
      floating
      stateless
    >
      <v-img :aspect-ratio="4/3"
        max-height="420" contain :lazy-src="url" :src="logo" />
      <v-list>
        <v-file-input
          v-if="can('editar_logo_empresa')"
          accept="image/png, image/jpeg, image/bmp"
          placeholder="Seleccione el logo de la empresa"
          prepend-icon="mdi-camera"
          label="Logo"
          show-size

          :rules="[rules.size]"
          @change="onFileChange"
        ></v-file-input>
      </v-list>
    </v-navigation-drawer>
  </v-col>
  <v-col cols="12" xl="8">
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="reset"
      @keydown="form.onKeydown($event)"
    >
      <div grid-list-xl>
        <form-toolbar
          :title="title"
          :loading="form.busy"
          @save="save"
          @cancel="cancel"
          v-if="!enterpriseId"
        />
        <v-layout
          :id="ref"
          class="wrap form-body"
        >
          <v-col
            cols="5"
            md="5"
          >
            <v-select
              v-model="form.type_document"
              :items="items_type_document"
              :rules="[rules.required]"
              label="Tipo de Documento"
              placeholder="Tipo de Documento"
              required
              :readonly="readonly"
            />
          </v-col>
          <v-col
            cols="5"
            md="5"
            lg="5"
          >
            <v-text-field
              v-model="form.rif"
              :rules="[rules.required, rules.rucLength, rules.rucFormat]"
              v-mask="'A-#########'"
              label="Número de Identificación"
              maxlength="11"
              placeholder="RIF"
              required
              :readonly="readonly"
            />
          </v-col>
          <v-col
            cols="2"
            md="2"
            lg="2"
          >
            <v-btn
              class="ml-1"
              color="success"
              :loading="form.busy"
              @click="save"
              v-if="enterpriseId && can('editar_datos_empresa')"
            >
              <v-icon text>
                mdi-content-save-edit
              </v-icon>
            </v-btn>
          </v-col>
          <v-col
             cols="12"
             md="6">
              <v-select
                v-model="form.taxpayer_type"
                :items="items_taxpayer_type"
                :rules="[rules.required]"
                label="Tipo de Contribuyente"
                placeholder="Tipo de Contribuyente"
                required
                :readonly="readonly"
              />
            </v-col>
            <v-col
                cols="12"
                md="6">
                <v-select
                  v-model="form.special_tax"
                  :items="items_special_tax"
                  label="Régimen Especial de Tributación"
                  placeholder="Régimen Especial de Tributación"
                  :readonly="readonly"
                />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="form.name"
              :rules="[rules.required]"
              label="Razón Social"
              placeholder="Razón Social"
              required
              :readonly="readonly"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
            >
            <v-text-field
              v-model="form.email"
              :rules="[rules.required, rules.emailFormat]"
              label="Correo Electrónico"
              placeholder="ejemplo@dominio.com"
              required
              :readonly="readonly"
            />
          </v-col>
          <v-col
              cols="12"
              md="12"
              >
            <vuetify-select-api
              :api="activity.apiActivities"
              :multiple="activity.multiple"
              :placeholder="activity.placeholder"
              @eventupdate="updateActivities"
              :selected="activity.selectedActivities"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="form.branch_code"
              :rules="[rules.required, rules.alphanumeric, rules.codeLength]"
              label="Sucursal"
              maxlength="4"
              placeholder="0001"
              required
              :readonly="readonly"
            />
          </v-col>
          <v-col
            cols="12"
            md="3">
            <v-select
              v-model="form.cat_province_id"
              :items="itemsProvince"
              item-value="id"
              item-text="name"
              :rules="[rules.required]"
              label="Estado"
              required
              @change="getDistrito()"
              :readonly="readonly"
            />
          </v-col>
          <v-col
            cols="12"
            md="3">
            <v-select
              v-model="form.cat_district_id"
              :items="itemsDistrict"
              item-value="id"
              item-text="name"
              :rules="[rules.required]"
              label="Municipio"
              required
              @change="getCorregimiento()"
              :readonly="readonly"
            />
          </v-col>
          <v-col
            cols="12"
            md="3">
            <v-select
              v-model="form.cat_corregimiento_id"
              :items="itemsMunicipality"
              item-value="id"
              item-text="name"
              :rules="[rules.required]"
              label="Parroquia"
              required
              :readonly="readonly"
            />
          </v-col>
          <v-col
            cols="12"
            md="9"
          >
            <v-text-field
              v-model="form.address"
              :rules="[rules.required]"
              label="Dirección"
              placeholder="Dirección"
              required
              :readonly="readonly"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-model="form.phone"
               v-mask="'####-###-####'"
              :rules="[rules.required, rules.phoneLength]"
              label="Teléfono"
              placeholder="0123-456-7890"
              maxlength="13"
              type="tel"
              required
              :readonly="readonly"
            />
          </v-col>
          <v-col
                cols="12"
                md="6"
                v-if="enterprise && enterprise.type === 1 && this.$router.currentRoute.path !== '/empresas/agregar'
                && (this.user.role === 1 || this.user.role === 2 || this.user.role === 7)">
                <v-select
                  v-model="form.delivery_method"
                  :items="items_delivery_method"
                  label="Modo de Envío"
                  placeholder="Modo de Envío"
                  :readonly="readonly"
                />
          </v-col>
          <v-col
                cols="12"
                md="3"
                v-if="enterprise && enterprise.type === 1 && this.$router.currentRoute.path !== '/empresas/agregar'
                && (this.user.role === 1 || this.user.role === 2 || this.user.role === 7)">
                <v-select
                  v-model="form.modality"
                  :items="itemsModality"
                  label="Modalidad"
                  placeholder="Modalidad"
                  :readonly="readonly"
                />
          </v-col>
          <v-col
                v-if="this.user.role === 1 || this.user.role === 2 || this.user.role === 7"
                cols="12"
                md="3"
               >
                <v-text-field
                  v-model="form.negotiate_controls"
                  :rules="[rules.numeric]"
                  label="Controles Negociados"
                  placeholder="75%"
                />
          </v-col>
          <v-col
                v-if="this.user.role === 1 || this.user.role === 2 || this.user.role === 7"
                cols="12"
                md="3"
                >
                <v-select
                  v-model="form.retention_percentage"
                  :items="itemsPercentage"
                  label="Porcentaje de Retención"
                  placeholder="Porcentaje de Retención"
                />
          </v-col>
          <v-col
                v-if="(this.user.role === 1 || this.user.role === 2 || this.user.role === 7) && form.send_order === 1"
                cols="12"
                md="3"
                >
                <v-select
                  v-model="form.mode_order"
                  :items="itemsOrder"
                  label="Modalidad Envío de Ordenes"
                  placeholder="Modalidad Envío de Ordenes"
                />
          </v-col>
          <v-col
            v-if="(this.user.role === 1 || this.user.role === 2) && (form.send_whatsapp === 1 || form.send_whatsapp === 2)"
            cols="12"
            md="3"
            >
            <v-select
              v-model="form.send_file_whatsapp"
              :items="itemsWhatsapp"
              label="Modalidad Envío Whatsapp"
              placeholder="Modalidad Envío Whatsapp"
          />
          </v-col>
          <v-col
            v-if="(this.user.role === 1 || this.user.role === 2) && (form.send_whatsapp === 1 || form.send_whatsapp === 2)"
            cols="12"
            md="3"
            >
            <v-select
              v-model="form.whatsapp_provider"
              :items="itemsWhatsappProvider"
              label="Proveedor Envío Whatsapp"
              placeholder="Proveedor Envío Whatsapp"
              @change="selectProvider"
          />
          </v-col>
          <v-col
            v-if="(this.user.role === 1 || this.user.role === 2 || this.user.role === 7)"
            cols="12"
            md="3"
            >
            <v-select
              v-model="form.seller_id"
              :items="itemsSeller"
              item-value="id"
              item-text="name"
              label="Vendedores"
              placeholder="Listado de Vendedores"
            />
          </v-col>
          <v-col
            v-if="(this.user.role === 1 || this.user.role === 2 || this.user.role === 7)"
            cols="12"
            md="3"
            >
            <v-select
              v-model="form.client_type"
              :items="itemsClientType"
              item-value="id"
              item-text="name"
              label="Tipo de Cliente"
              placeholder="Tipo de Cliente"
            />
          </v-col>
          <v-col
            v-if="(this.user.role === 1 || this.user.role === 2) && (form.external_pdf === 1)"
            cols="12"
            md="4"
            >
            <v-text-field
                v-model="form.url_pdf"
                label="Url PDF"
                placeholder=""
              />
          </v-col>
          <!-- <v-col
            v-if="(this.user.role === 1 || this.user.role === 2 || this.user.role === 9)"
            cols="12"
            md="3"
          >
            <v-text-field
              v-if="form.payroll === 1"
              v-model="form.total"
              :rules="[rules.numeric, rules.maximo]"
              label="Cantidad Empleados Máx."
              placeholder="100"
              maxlength="9"
            />
          </v-col> -->
          <v-col
            v-if="this.user.role === 1 || this.user.role === 2 || this.user.role === 7"
            cols="12"
            md="12"
          >
            <v-chip v-if="form.folder === true" label :color="form.folder?'success':'red'" text-color="white">
              <v-icon left>mdi-check-circle</v-icon>
              {{ 'Credenciales SFTP correctos.' }}
            </v-chip>
            <v-chip v-if="form.folder === false" label :color="form.folder?'success':'red'" text-color="white">
              <v-icon left>mdi-close-circle</v-icon>
              {{ 'Credenciales SFTP Errados o sin carpeta creada.' }}
            </v-chip>
          </v-col>
        </v-layout>
      </div>
    </v-form>
  </v-col>
  <v-col cols="12">
    <v-card>
      <v-tabs
        v-model="tab"
        centered
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-ID" v-if="enterprise && (enterprise.type === 1)
            && this.$router.currentRoute.path !== '/empresas/agregar'
            && (this.user.role === 1 || this.user.role === 2)">
          Imprenta Digital
        </v-tab>
        <v-tab href="#tab-nomina" v-if="enterprise && (enterprise.payroll === 1)
            && this.$router.currentRoute.path !== '/empresas/agregar'
            && (this.user.role === 1 || this.user.role === 2)">
          Nómina
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-ID" >
          <div class="col-md-12" v-if="enterprise && (enterprise.type === 1)
            && this.$router.currentRoute.path !== '/empresas/agregar'
            && (this.user.role === 1 || this.user.role === 2)">
            <v-skeleton-loader
                type="list-item-two-line"
                :loading="loadingTable"
                transition="scale-transition"
              >
              <v-data-table
                :headers="headers"
                :items="(enterprise.type === 1) ? items : itemsID"
                :class="`elevation-1 ${navbarColor}`"
              >
              <template v-slot:item.name="{ item }">
                    {{ item.name }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-switch
                      v-if="can(item.permission)"
                      :color="themeColor"
                      v-model="item.value"
                      @click.prevent="openModalGeneral(item)"
                    />
                    <div v-else>
                    <v-tooltip bottom >
                      <template v-slot:activator="{ on,attrs }">
                        <v-icon color="red darken-1"
                          v-bind="attrs"
                          v-on="on">
                          mdi-close
                        </v-icon>
                      </template>
                      <span>Permiso Denegado</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </v-skeleton-loader>
          </div>
        </v-tab-item>
        <v-tab-item value="tab-nomina" >
          <div class="col-md-12" v-if="enterprise && (enterprise.payroll === 1)
            && this.$router.currentRoute.path !== '/empresas/agregar'
            && (this.user.role === 1 || this.user.role === 2)">
            <v-skeleton-loader
                type="list-item-two-line"
                :loading="loadingTable"
                transition="scale-transition"
              >
              <v-data-table
                :headers="headers"
                :items="itemsNomina"
                :class="`elevation-1 ${navbarColor}`"
              >
              <template v-slot:item.name="{ item }">
                    {{ item.name }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-switch
                      v-if="can(item.permission)"
                      :color="themeColor"
                      v-model="item.value"
                      @click.prevent="openModalGeneral(item)"
                    />
                    <div v-else>
                    <v-tooltip bottom >
                      <template v-slot:activator="{ on,attrs }">
                        <v-icon color="red darken-1"
                          v-bind="attrs"
                          v-on="on">
                          mdi-close
                        </v-icon>
                      </template>
                      <span>Permiso Denegado</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </v-skeleton-loader>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-col>
  <v-dialog
    v-model="dialogStatusNotify"
    max-width="860"
  >
    <v-card v-if="form.notify_fel === 0">
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusNotify }} el envió de credenciales ID?
      </v-card-title>
      <v-card-text>
        <v-col
          cols="12"
          >
          <v-text-field
            v-model="cc_email"
            label="CC. Correo Electrónico"
            placeholder="ejemplo@dominio.com"
            required
          />
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusNotify = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingNotify"
          @click.prevent="toggleNotify()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres reiniciar el envió de credenciales ID?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusNotify = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingNotify"
          @click.prevent="toggleNotify()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusNotifyRecepcion"
    max-width="870"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusNotifyRecepcion }} el envió de credenciales de Recepción?
      </v-card-title>
      <v-card-text
        class="headline"
        color="red"
      >
        No podra deshacer esta acción.
      </v-card-text>
      <v-card-text>
        <v-col
          cols="12"
          >
          <v-text-field
            v-model="cc_email"
            label="CC. Correo Electrónico"
            placeholder="ejemplo@dominio.com"
            required
          />
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusNotifyRecepcion = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingNotifyRecepcion"
          @click.prevent="toggleNotifyRecepcion()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusNotifyNomina"
    max-width="870"
  >
    <v-card v-if="form.notify_payroll === 0">
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusNotifyNomina }} el envió de credenciales de Nómina?
      </v-card-title>
      <v-card-text
        class="headline"
        color="red"
      >
        No podra deshacer esta acción.
      </v-card-text>
      <v-card-text>
        <v-col
          cols="12"
          >
          <v-text-field
            v-model="cc_email"
            label="CC. Correo Electrónico"
            placeholder="ejemplo@dominio.com"
            required
          />
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusNotifyNomina = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingNotifyNomina"
          @click.prevent="toggleNotifyNomina()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres reiniciar el envió de credenciales nómina?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusNotifyNomina = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingNotifyNomina"
          @click.prevent="toggleNotifyNomina()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusMail"
    max-width="750"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusMail }} el envío de correo de forma automatica?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusMail = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingMail"
          @click.prevent="toggleMail()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusSalesBook"
    max-width="750"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusSalesBook }} las peticiones de libro de ventas?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusSalesBook = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingSalesBook"
          @click.prevent="toggleSalesBook()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusBatches"
    max-width="750"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusBatches }} el procesamiento de lotes?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusBatches = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingBatches"
          @click.prevent="toggleBatches()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusLogs"
    max-width="750"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusLogs }} el logs de errores?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusLogs = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingLogs"
          @click.prevent="toggleLogsError()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusWebBilling"
    max-width="750"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusWebBilling }} la facturación web?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusWebBilling = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingWebBilling"
          @click.prevent="toggleWebBilling()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusAnnulment"
    max-width="750"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusAnnulment }} las anulaciones?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusAnnulment = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingAnnulment"
          @click.prevent="toggleAnnulment()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusRetention"
    max-width="750"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusRetention }} las retenciones?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusRetention = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingRetention"
          @click.prevent="toggleRetention()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusReceipt"
    max-width="750"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusReceipt }} el acuse de recibo?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusReceipt = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingReceipt"
          @click.prevent="toggleReceipt()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusSendSMS"
    max-width="800"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusSendSMS }} el envío de mensjes de texto?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusSendSMS = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingSendSMS"
          @click.prevent="toggleSendSMS()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusAssociationTask"
    max-width="800"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusAssociationTask }} las asociaciones efectivas?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusAssociationTask = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingAssociationTask"
          @click.prevent="toggleAssociationTask()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusSendOrder"
    max-width="800"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusSendOrder }} el envío de ordenes?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusSendOrder = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingSendOrder"
          @click.prevent="toggleSendOrder()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusSendWhatsApp"
    max-width="730"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusSendWhatsApp }} el envío de mensajes de WhatsApp?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusSendWhatsApp = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingSendWhatsApp"
          @click.prevent="toggleSendWhatsApp()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusCodeQR"
    max-width="720"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusCodeQR }} el código QR?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusCodeQR = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingCodeQR"
          @click.prevent="toggleCodeQR()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusPayment"
    max-width="720"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusPayment }} el Botón de Pago?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusPayment = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingPayment"
          @click.prevent="togglePayment()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusOnlyIGTF"
    max-width="720"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusOnlyIGTF }} el ND solo IGTF?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusOnlyIGTF = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingOnlyIGTF"
          @click.prevent="toggleOnlyIGTF()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusLVNegative"
    max-width="720"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusLVNegative }} el Libro de Ventas con Montos Negativos?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusLVNegative = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingLVNegative"
          @click.prevent="toggleLVNegative()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusWebPayroll"
    max-width="750"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusWebPayroll }} la nómina web?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusWebPayroll = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingWebPayroll"
          @click.prevent="toggleWebPayroll()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusCustomer"
    max-width="720"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusCustomer }} el Portal Cliente?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusCustomer = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingCustomer"
          @click.prevent="toggleCustomer()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusExternalPdf"
    max-width="720"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusExternalPdf }} el PDF Externo?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusExternalPdf = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingExternalPdf"
          @click.prevent="toggleExternalPdf()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusOtherCurrency"
    max-width="720"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusOtherCurrency }} Otra Moneda?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusOtherCurrency = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingOtherCurrency"
          @click.prevent="toggleOtherCurrency()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusFiscalValidation"
    max-width="720"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusFiscalValidation }} Validación Fiscal?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusFiscalValidation = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingFiscalValidation"
          @click.prevent="toggleFiscalValidation()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="dialogStatusPaymentQuote"
    max-width="720"
  >
    <v-card>
      <v-card-title class="headline">
        ¿Estás seguro de que quieres {{ this.titleStatusPaymentQuote }} Validación Fiscal?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error darken-1"
          text
          @click="dialogStatusPaymentQuote = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :loading="loadingPaymentQuote"
          @click.prevent="togglePaymentQuote()"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-row>

</template>

<script>
  import { mapGetters } from 'vuex';
  import Form from 'vform';
  import { mask } from 'vue-the-mask';
  import FormToolbar from '~/components/Form/Toolbar';
  import VuetifySelectApi from '~/components/VuetifySelectApi';

  export default {
    metaInfo() {
      return { title: this.$t('enterprises') };
    },
    components: {
      FormToolbar,
      VuetifySelectApi,
    },
    directives: {
      mask,
    },
    props: {
      enterpriseId: { default: null },
    },
    data: () => ({
      tab: null,
      form: new Form({
        type_document: null,
        rif: null,
        taxpayer_type: null,
        special_tax: null,
        name: null,
        email: null,
        phone: null,
        address: null,
        branch_code: null,
        cat_corregimiento_id: null,
        cat_district_id: null,
        cat_province_id: null,
        active: '1',
        notify_fel: '0',
        notifyRecepcion: '0',
        notify_payroll: '0',
        send_mail: '0',
        busy: false,
        sales_book: '0',
        batches: '0',
        logs: '0',
        web_billing: '0',
        web_payroll: '0',
        annulment: '0',
        retention: '0',
        receipt: '0',
        send_sms: '0',
        association_task: '0',
        activities_code: [],
        delivery_method: '0',
        modality: '0',
        negotiate_controls: '0',
        send_order: '0',
        mode_order: '0',
        send_whatsapp: '0',
        code_qr: '0',
        send_file_whatsapp: '0',
        whatsapp_provider: '0',
        total: '0',
        folder: '',
        actividad: [],
        payment: '0',
        only_IGTF: '0',
        lv_negative: '0',
        seller_id: null,
        client_type: null,
        payroll: 0,
        customer_portal: '0',
        external_pdf: '0',
        url_pdf: '0',
        other_currency: '0',
        fiscal_validation: '0',
        payment_quote: '0',
      }),
      cc_email: '',
      app: '',
      titleStatusNotify: '',
      titleStatusNotifyRecepcion: '',
      titleStatusNotifyNomina: '',
      titleStatusMail: '',
      titleStatusSalesBook: '',
      titleStatusBatches: '',
      titleStatusLogs: '',
      titleStatusWebBilling: '',
      titleStatusWebPayroll: '',
      titleStatusAnnulment: '',
      titleStatusRetention: '',
      titleStatusReceipt: '',
      titleStatusSendSMS: '',
      titleStatusAssociationTask: '',
      titleStatusSendOrder: '',
      titleStatusSendWhatsApp: '',
      titleStatusCodeQR: '',
      titleStatusPayment: '',
      titleStatusOnlyIGTF: '',
      titleStatusSendFileWhatsApp: '',
      titleStatusLVNegative: '',
      titleStatusCustomer: '',
      titleStatusExternalPdf: '',
      titleStatusOtherCurrency: '',
      titleStatusFiscalValidation: '',
      titleStatusPaymentQuote: '',
      dialogStatusNotify: false,
      dialogStatusNotifyRecepcion: false,
      dialogStatusNotifyNomina: false,
      dialogStatusMail: false,
      dialogStatusSalesBook: false,
      dialogStatusBatches: false,
      dialogStatusLogs: false,
      dialogStatusWebBilling: false,
      dialogStatusWebPayroll: false,
      dialogStatusAnnulment: false,
      dialogStatusRetention: false,
      dialogStatusReceipt: false,
      dialogStatusSendSMS: false,
      dialogStatusAssociationTask: false,
      dialogStatusSendOrder: false,
      dialogStatusSendWhatsApp: false,
      dialogStatusCodeQR: false,
      dialogStatusPayment: false,
      dialogStatusOnlyIGTF: false,
      dialogStatusLVNegative: false,
      dialogStatusCustomer: false,
      dialogStatusExternalPdf: false,
      dialogStatusOtherCurrency: false,
      dialogStatusFiscalValidation: false,
      dialogStatusPaymentQuote: false,
      loadingNotify: false,
      loadingNotifyRecepcion: false,
      loadingNotifyNomina: false,
      loadingMail: false,
      loadingSalesBook: false,
      loadingBatches: false,
      loadingLogs: false,
      loadingWebBilling: false,
      loadingWebPayroll: false,
      loadingAnnulment: false,
      loadingRetention: false,
      loadingReceipt: false,
      loadingSendSMS: false,
      loadingAssociationTask: false,
      loadingSendOrder: false,
      loadingSendWhatsApp: false,
      loadingCodeQR: false,
      loadingTable: false,
      loadingPayment: false,
      loadingOnlyIGTF: false,
      loadingLVNegative: false,
      loadingCustomer: false,
      loadingExternalPdf: false,
      loadingOtherCurrency: false,
      loadingFiscalValidation: false,
      loadingPaymentQuote: false,
      url: 'https://cdn.vuetifyjs.com/images/parallax/material.jpg',
      searching: false,
      itemsProvince: [],
      itemsDistrict: [],
      itemsMunicipality: [],
      items_type_document: [
        { value: 'J', text: 'JURÍDICO' },
        { value: 'V', text: 'VENEZOLANO' },
        { value: 'C', text: 'CEDULA' },
        { value: 'P', text: 'PASAPORTE' },
        { value: 'G', text: 'GUBERNAMENTAL' },
        { value: 'E', text: 'EXTRANJERO' },
      ],
      items_taxpayer_type: [
        { value: 'FORMAL', text: '  FORMAL' },
        { value: 'ORDINARIO', text: 'ORDINARIO' },
        { value: 'ESPECIAL', text: 'ESPECIAL' },
        { value: 'NO SUJETO', text: 'NO SUJETO' },
      ],
      items_special_tax: [
        { value: 'ZONAS ECONÓMICAS ESPECIALES', text: 'ZONAS ECONÓMICAS ESPECIALES' },
        { value: 'ZONA FRANCA DE PARAGUANÁ', text: 'ZONA FRANCA DE PARAGUANÁ' },
        { value: 'ZONA LIBRE DE PARAGUANÁ', text: 'ZONA LIBRE DE PARAGUANÁ' },
        { value: 'PUERTO LIBRE SANTA ELENA DE UAIRÉN', text: 'PUERTO LIBRE SANTA ELENA DE UAIRÉN' },
        { value: 'ZONA LIBRE DE MÉRIDA', text: 'ZONA LIBRE DE MÉRIDA' },
        { value: 'PUERTO LIBRE EDO. NUEVA ESPARTA', text: 'PUERTO LIBRE EDO. NUEVA ESPARTA' },
        { value: 'DUTTY FREE', text: 'DUTTY FREE' },
        { value: 'OTROS', text: 'OTROS' },
      ],
      items_delivery_method: [
        { value: 0, text: 'Operativa Actual (Funcionamiento normal de la Imprenta Digital)' },
        { value: 1, text: 'Asignación Automática (El número de control y la numeración se asignarán de acuerdo al último emitido)' },
        { value: 2, text: 'Validaciones Mínimas (Se permite sólo recibir la información básica del documento de acuerdo al Art 32)' },
      ],
      itemsModality: [
        { value: 0, text: 'Prepago' },
        { value: 1, text: 'Postpago' },
      ],
      itemsPercentage: [
        { value: 0, text: '0%' },
        { value: 75, text: '75%' },
        { value: 100, text: '100%' },
      ],
      itemsOrder: [
        { value: 0, text: 'Automático' },
        { value: 1, text: 'Manual' },
      ],
      itemsPaymentMethod: [
        { value: 0, text: 'SYPAGO' },
      ],
      itemsWhatsapp: [
        { value: 1, text: 'Envío Básico' },
        { value: 2, text: 'Envío Adjunto' },
      ],
      itemsWhatsappProvider: [
        { value: 0, text: 'Waha' },
        { value: 1, text: 'BSP' },
      ],
      itemsActivitiesAll: [],
      logo: '',
      success: null,
      valid: false,
      userAdmin: false,
      userCom: false,
      readonly: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
        rucLength: (v) => (!v || v.length === 11) || 'El campo debe tener de 11 caracteres.',
        rucFormat: (v) => /^[V,J,E,P,G]{1}[-][0-9]{9}$/.test(v) || 'El formato no corresponde.',
        phoneLength: (v) => (!v || v.length === 13) || 'El campo debe tener de 11 caracteres numéricos.',
        codeLength: (v) => (!!v && v.length === 4) || 'El campo debe tener de 4 caracteres alfanumericos.',
        alphanumeric: (v) => /^[a-zA-Z0-9]*$/.test(v) || 'El campo solo permite caracteres alfanumericos.',
        emailFormat: (v) => /.+@.+\..+/.test(v) || 'El campo debe tener un correo electrónico válido.',
        size: (v) => !v || v.size < 2000000 || 'Su logo no debe exceder los 2MB de tamaño.',
        numeric: (v) => /^[0-9]+$/.test(v) || 'El campo solo permite numeros.',
        maximo: (v) => (!v || v.length <= 9) || 'Máximo 9 caracteres',
        urlValida: (v) => /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/.test(v) || 'El campo debe tener una válida.',
      },
      headers: [
        {
          text: 'Configuracion de:',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Acción',
          value: 'action',
          sortable: false,
        },
      ],
      items: [
        {
          name: 'Credenciales',
          action: 'notify_fel',
          permission: 'credenciales_imprenta_digital',
          value: 0,
        },
        {
          name: 'Facturación Web',
          action: 'web_billing',
          permission: 'facturacion_web',
          value: 0,
        },
        {
          name: 'Envío de Correos Automáticos',
          action: 'send_mail',
          permission: 'correos_automaticos',
          value: 0,
        },
        {
          name: 'Libro de Ventas',
          action: 'sales_book',
          permission: 'libro_de_ventas',
          value: 0,
        },
        {
          name: 'Lotes de Procesamiento',
          action: 'batches',
          permission: 'lotes_de_procesamiento',
          value: 0,
        },
        {
          name: 'Logs de Errores',
          action: 'logs_error',
          permission: 'logs_error',
          value: 0,
        },
        {
          name: 'Anulaciones',
          action: 'annulment',
          permission: 'aplicar_anulaciones',
          value: 0,
        },
        {
          name: 'Retenciones',
          action: 'retention',
          permission: 'aplicar_retenciones',
          value: 0,
        },
        {
          name: 'Acuse de Recibo',
          action: 'receipt',
          permission: 'acuse_recibo',
          value: 0,
        },
        {
          name: 'Envío de SMS',
          action: 'send_sms',
          permission: 'envio_sms',
          value: 0,
        },
        {
          name: 'Asociaciones Efectivas',
          action: 'association_task',
          permission: 'asociacion_efectiva',
          value: 0,
        },
        {
          name: 'Envío de Orden',
          action: 'send_order',
          permission: 'envio_orden',
          value: 0,
        },
        {
          name: 'Envío de WhatsApp',
          action: 'send_whatsapp',
          permission: 'envio_whatsapp',
          value: 0,
        },
        {
          name: 'Código QR',
          action: 'code_qr',
          permission: 'codigo_qr',
          value: 0,
        },
        {
          name: 'Botón de Pago',
          action: 'payment',
          permission: 'boton_de_pago',
          value: 0,
        },
        {
          name: 'ND Solo IGTF',
          action: 'only_IGTF',
          permission: 'solo_IGTF',
          value: 0,
        },
        {
          name: 'Libro de Ventas Montos Negativos',
          action: 'lv_negative',
          permission: 'libro_venta_negativo',
          value: 0,
        },
        {
          name: 'Portal Cliente',
          action: 'customer_portal',
          permission: 'portal_cliente',
          value: 0,
        },
        {
          name: 'PDF Externo',
          action: 'external_pdf',
          permission: 'pdf_externo',
          value: 0,
        },
        {
          name: 'Otra Moneda',
          action: 'other_currency',
          permission: 'otra_moneda',
          value: 0,
        },
        {
          name: 'Validación Fiscal',
          action: 'fiscal_validation',
          permission: 'validacion_fiscal',
          value: 0,
        },
        {
          name: 'Botón de Pago Cotizaciones',
          action: 'payment_quote',
          permission: 'boton_de_pago_cotizacion',
          value: 0,
        },
      ],
      itemsNomina: [
        {
          name: 'Credenciales Nómina',
          action: 'notify_payroll',
          permission: 'credenciales_nomina',
          value: 0,
        },
        {
          name: 'Nómina Web',
          action: 'web_payroll',
          permission: 'nomina_web',
          value: 0,
        },
      ],
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: 'Nueva Empresa',
      apiURL: '/api/enterprises/store',
      method: 'POST',
      activity: {
        selectedActivities: null,
        apiActivities: '/api/catalogs/activities/Todos',
        multiple: true,
        placeholder: 'Actividades Comerciales',
      },
      itemsSeller: [],
      itemsClientType: [
        {
          id: 1,
          name: 'Optativo',
        },
        {
          id: 2,
          name: 'Obligatorio',
        },
        {
          id: 3,
          name: 'Híbrido',
        },
      ],
    }),
    computed: {
      ref() { return this.form.id; },
      enterprise() {
        return this.$store.state.profile.enterprise;
      },
      justify() {
        return this.enterpriseId && this.enterprise.type ? 'start' : 'center';
      },
      ...mapGetters({
        themeColor: 'theme/themeColor',
        navbarColor: 'theme/navbarColor',
        user: 'auth/user',
      }),
    },
    watch: {
      'form.cat_province_id': {
        handler() {
          this.getDistrito();
        },
      },
      'form.cat_district_id': {
        handler() {
          this.getCorregimiento();
        },
      },
    },
    async mounted() {
      if (this.enterpriseId) {
          this.app = this.enterprise.type;
           window.axios.get(`/api/enterprises/${this.enterpriseId}/logo`)
           .then((result) => {
             this.logo = result.data.Archivo ? `data:image/png;base64, ${result.data.Archivo}` : '';
           });

          Object.assign(this.form, this.enterprise);
          this.apiURL = `/api/enterprises/${this.enterpriseId}/update`;
          this.method = 'PUT';
          this.title = `Editar Empresa ${this.enterprise.rif} - ${this.enterprise.name}`;
          this.message = `Se ha editado la empresa ${this.enterprise.name} exitosamente.`;
          await this.getEnterprises().then((result) => {
             this.activity.selectedActivities = JSON.parse(result.data.activity);
             this.form.notifyRecepcion = result.data.notify_rep;
             this.form.notify_fel = result.data.notify_fel;
             this.items[0].value = this.form.notify_fel;
             this.form.web_billing = result.data.web_billing;
             this.items[1].value = this.form.web_billing;
             this.form.sendMail = result.data.send_mail;
             this.items[2].value = this.form.sendMail;
             this.form.sales_book = result.data.sales_book;
             this.items[3].value = this.form.sales_book;
             this.form.processBatches = result.data.batches;
             this.items[4].value = this.form.processBatches;
             this.form.logs_error = result.data.logs;
             this.items[5].value = this.form.logs_error;
             this.form.annulment = result.data.annulment;
             this.items[6].value = this.form.annulment;
             this.form.retention = result.data.retention;
             this.items[7].value = this.form.retention;
             this.form.receipt = result.data.receipt;
             this.items[8].value = this.form.receipt;
             this.form.send_sms = result.data.send_sms;
             this.items[9].value = this.form.send_sms;
             this.form.association_task = result.data.association_task;
             this.items[10].value = this.form.association_task;
             this.form.negotiate_controls = result.data.negotiate_controls;
             this.updateActivities(this.activity.selectedActivities);
             this.form.send_order = result.data.send_order;
             this.items[11].value = this.form.send_order;
             this.form.send_whatsapp = result.data.send_whatsapp;
             this.items[12].value = this.form.send_whatsapp;
             this.form.code_qr = result.data.code_qr;
             this.items[13].value = this.form.code_qr;
             this.form.payment = result.data.payment;
             this.items[14].value = this.form.payment;
             this.form.only_IGTF = result.data.only_IGTF;
             this.items[15].value = this.form.only_IGTF;
             this.form.lv_negative = result.data.lv_negative;
             this.items[16].value = this.form.lv_negative;
             this.form.customer_portal = result.data.customer_portal;
             this.items[17].value = this.form.customer_portal;
             this.form.external_pdf = result.data.external_pdf;
             this.items[18].value = this.form.external_pdf;
             this.form.other_currency = result.data.other_currency;
             this.items[19].value = this.form.other_currency;
             this.form.fiscal_validation = result.data.fiscal_validation;
             this.items[20].value = this.form.fiscal_validation;
             this.form.payment_quote = result.data.payment_quote;
             this.items[21].value = this.form.payment_quote;
             this.form.total = result.data.total.toString();
             this.form.payroll = result.data.payroll;
             this.form.url_pdf = result.data.url_pdf;

             this.form.notify_payroll = result.data.notify_payroll;
             this.itemsNomina[0].value = this.form.notify_payroll;
             this.form.web_payroll = result.data.web_payroll;
             this.itemsNomina[1].value = this.form.web_payroll;

            if (this.form.notify_fel === 0) {
              this.titleStatusNotify = 'activar';
            } else {
              this.titleStatusNotify = 'inactivar';
            }

            if (this.form.notifyRecepcion === 0) {
              this.titleStatusMail = 'activar';
            } else {
              this.titleStatusMail = 'inactivar';
            }

            if (this.form.notify_payroll === 0) {
              this.titleStatusNotifyPayroll = 'activar';
            } else {
              this.titleStatusNotifyPayroll = 'inactivar';
            }


            if (this.form.sendMail === 0) {
              this.titleStatussendMail = 'activar';
            } else {
              this.titleStatussendMail = 'inactivar';
            }

            if (this.form.sales_book === 0) {
              this.titleStatusSalesBook = 'activar';
            } else {
              this.titleStatusSalesBook = 'inactivar';
            }

            if (this.form.processBatches === 0) {
              this.titleStatusBatches = 'activar';
            } else {
              this.titleStatusBatches = 'inactivar';
            }

            if (this.form.logs_error === 0) {
              this.titleStatusLogs = 'activar';
            } else {
              this.titleStatusLogs = 'inactivar';
            }

            if (this.form.web_billing === 0) {
              this.titleStatusWebBilling = 'activar';
            } else {
              this.titleStatusWebBilling = 'inactivar';
            }

            if (this.form.annulment === 0) {
              this.titleStatusAnnulment = 'activar';
            } else {
              this.titleStatusAnnulment = 'inactivar';
            }

            if (this.form.retention === 0) {
              this.titleStatusRetention = 'activar';
            } else {
              this.titleStatusRetention = 'inactivar';
            }

            if (this.form.receipt === 0) {
              this.titleStatusReceipt = 'activar';
            } else {
              this.titleStatusReceipt = 'inactivar';
            }

            if (this.form.send_sms === 0) {
              this.titleStatusSendSMS = 'activar';
            } else {
              this.titleStatusSendSMS = 'inactivar';
            }

            if (this.form.association_task === 0) {
              this.titleStatusAssociationTask = 'activar';
            } else {
              this.titleStatusAssociationTask = 'inactivar';
            }

            if (this.form.send_order === 0) {
              this.titleStatusSendOrder = 'activar';
            } else {
              this.titleStatusSendOrder = 'inactivar';
            }

            if (this.form.web_payroll === 0) {
              this.titleStatusWebPayroll = 'activar';
            } else {
              this.titleStatusWebPayroll = 'inactivar';
            }

            if (this.form.send_whatsapp === 0) {
              this.titleStatusSendWhatsApp = 'activar';
            } else if (this.form.send_whatsapp === 1) {
              this.form.send_file_whatsapp = 1;
              this.titleStatusSendWhatsApp = 'inactivar';
            } else if (this.form.send_whatsapp === 2) {
              this.form.send_file_whatsapp = 2;
              this.titleStatusSendWhatsApp = 'inactivar';
            }
            if (this.form.code_qr === 0) {
              this.titleStatusCodeQR = 'activar';
            } else {
              this.titleStatusCodeQR = 'inactivar';
            }

            if (this.form.payment === 0) {
              this.titleStatusPayment = 'activar';
            } else {
              this.titleStatusPayment = 'inactivar';
            }
            if (this.form.only_IGTF === 0) {
              this.titleStatusOnlyIGTF = 'activar';
            } else {
              this.titleStatusOnlyIGTF = 'inactivar';
            }
            if (this.form.lv_negative === 0) {
              this.titleStatusLVNegative = 'activar';
            } else {
              this.titleStatusLVNegative = 'inactivar';
            }
            if (this.form.customer_portal === 0) {
              this.titleStatusCustomer = 'activar';
            } else {
              this.titleStatusCustomer = 'inactivar';
            }
            if (this.form.external_pdf === 0) {
              this.titleStatusExternalPdf = 'activar';
            } else {
              this.titleStatusExternalPdf = 'inactivar';
            }
            if (this.form.other_currency === 0) {
              this.titleStatusOtherCurrency = 'activar';
            } else {
              this.titleStatusOtherCurrency = 'inactivar';
            }
            if (this.form.fiscal_validation === 0) {
              this.titleStatusFiscalValidation = 'activar';
            } else {
              this.titleStatusFiscalValidation = 'inactivar';
            }
            if (this.form.payment_quote === 0) {
              this.titleStatusPaymentQuote = 'activar';
            } else {
              this.titleStatusPaymentQuote = 'inactivar';
            }
          });
          if (this.form.processBatches === 1) {
            this.checkSFTPCredentials();
          }
      }
      await this.getProvincia().then((response) => {
        this.itemsProvince = response.data;
      });
      await this.getSeller().then((response) => {
        if (response.data.code === 200) {
            const rawSellers = response.data.sellers;
            this.itemsSeller = rawSellers.map((seller) => seller);
          } else {
            this.itemsSeller = [];
          }
      });
    },

    methods: {
      getEnterprises() {
        const url = `/api/enterprises/${this.enterpriseId}`;
        return window.axios.get(url);
      },
      validate() {
        if (this.$refs.form.validate()) {
          this.snackbar = true;
          this.form.busy = true;
          this.store();
        }
      },
      store() {
        window.axios({
          method: this.method,
          url: this.apiURL,
          data: this.form,
        }).then(() => {
          if (!this.enterpriseId) {
            this.$router.go(-1);
          }
          if (this.newLogo) {
             const config = {
               headers: {
                   'content-type': 'multipart/form-data',
               },
             };
            window.axios.post(`/api/enterprises/${this.enterpriseId}/logo/store`, this.newLogo, config);
          }
        })
        .finally(() => {
          this.form.busy = false;
        });
      },
      save() {
        this.validate(); // someValue
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
      onFileChange(e) {
        this.logo = URL.createObjectURL(e);
        const formData = new FormData();
        formData.append('file', e);
        this.newLogo = formData;
      },
      openModalGeneral(item) {
        if (item.action === 'notify_fel') {
          this.dialogStatusNotify = true;
        } else if (item.action === 'notify_payroll') {
          this.dialogStatusNotifyNomina = true;
        } else if (item.action === 'send_mail') {
          this.dialogStatusMail = true;
        } else if (item.action === 'sales_book') {
          this.dialogStatusSalesBook = true;
        } else if (item.action === 'batches') {
          this.dialogStatusBatches = true;
        } else if (item.action === 'logs_error') {
          this.dialogStatusLogs = true;
        } else if (item.action === 'web_billing') {
          this.dialogStatusWebBilling = true;
        } else if (item.action === 'web_payroll') {
          this.dialogStatusWebPayroll = true;
        } else if (item.action === 'annulment') {
          this.dialogStatusAnnulment = true;
        } else if (item.action === 'retention') {
          this.dialogStatusRetention = true;
        } else if (item.action === 'receipt') {
          this.dialogStatusReceipt = true;
        } else if (item.action === 'send_sms') {
          this.dialogStatusSendSMS = true;
        } else if (item.action === 'association_task') {
          this.dialogStatusAssociationTask = true;
        } else if (item.action === 'send_order') {
          this.dialogStatusSendOrder = true;
        } else if (item.action === 'send_whatsapp') {
          this.dialogStatusSendWhatsApp = true;
        } else if (item.action === 'code_qr') {
          this.dialogStatusCodeQR = true;
        } else if (item.action === 'payment') {
          this.dialogStatusPayment = true;
        } else if (item.action === 'only_IGTF') {
          this.dialogStatusOnlyIGTF = true;
        } else if (item.action === 'lv_negative') {
          this.dialogStatusLVNegative = true;
        } else if (item.action === 'customer_portal') {
          this.dialogStatusCustomer = true;
        } else if (item.action === 'external_pdf') {
          this.dialogStatusExternalPdf = true;
        } else if (item.action === 'other_currency') {
          this.dialogStatusOtherCurrency = true;
        } else if (item.action === 'fiscal_validation') {
          this.dialogStatusFiscalValidation = true;
        } else if (item.action === 'payment_quote') {
          this.dialogStatusPaymentQuote = true;
        }
      },
      openModalStatusNotify(notifyFEL) {
          if (notifyFEL === 0) {
            this.dialogStatusNotify = true;
          }
      },
      openModalStatusNotifyRecepcion(notifyRecepcion) {
          if (notifyRecepcion === 0) {
            this.dialogStatusNotifyRecepcion = true;
          }
      },
      openModalStatusNotifyNomina(notifyNomina) {
          if (notifyNomina === 0) {
            this.dialogStatusNotifyNomina = true;
          }
      },
      openModalStatusMail() {
          this.dialogStatusMail = true;
      },
      openModalStatusSalesBook() {
          this.dialogStatusSalesBook = true;
      },
      openModalStatusBatches() {
          this.dialogStatusBatches = true;
      },
      openModalStatusLogs() {
          this.dialogStatusLogs = true;
      },
      toggleNotify() {
        this.loadingNotify = true;
        const url = `/api/enterprises/${this.enterpriseId}/notify_fel`;
        window.axios.put(url, {
            notify_fel: this.form.notify_fel,
            cc_email: this.cc_email,
          })
          .then((response) => {
            this.loadingNotify = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusNotify = false;
            if (this.form.notify_fel === 0) {
              this.titleStatusNotify = 'inactivar';
              this.form.notify_fel = 1;
              this.items[0].value = 1;

              this.form.notify_payroll = 1;
              this.itemsNomina[0].value = 1;
            } else {
              this.titleStatusNotify = 'activar';
              this.form.notify_fel = 0;
              this.items[0].value = 0;

              this.form.notify_payroll = 0;
              this.itemsNomina[0].value = 0;
            }
            this.cc_email = '';
            this.$router.go(0);
          });
      },
      toggleWebBilling() {
        this.loadingWebBilling = true;
        const url = `/api/enterprises/${this.enterpriseId}/web_billing`;
        window.axios.put(url, {
          web_billing: this.form.web_billing,
          })
          .then((response) => {
            this.loadingWebBilling = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusWebBilling = false;
            if (this.form.web_billing === 0) {
              this.switch = false;
              this.titleStatusWebBilling = 'inactivar';
              this.form.web_billing = 1;
              this.items[1].value = 1;
            } else {
              this.switch = true;
              this.titleStatusWebBilling = 'activar';
              this.form.web_billing = 0;
              this.items[1].value = 0;
            }
          });
      },
      toggleNotifyRecepcion() {
        this.loadingNotifyRecepcion = true;
        const url = `/api/enterprises/${this.enterpriseId}/notify_rep`;
        window.axios.put(url, {
            notify_rep: this.form.notifyRecepcion,
            cc_email: this.cc_email,
          })
          .then((response) => {
            this.loadingNotifyRecepcion = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusNotifyRecepcion = false;
            if (this.form.notifyRecepcion === 0) {
              this.titleStatusNotifyRecepcion = 'inactivar';
              this.form.notifyRecepcion = 1;
            } else {
              this.titleStatusNotifyRecepcion = 'activar';
              this.form.notifyRecepcion = 0;
            }
            this.cc_email = '';
          });
      },
      toggleNotifyNomina() {
        this.loadingNotifyNomina = true;
        const url = `/api/enterprises/${this.enterpriseId}/notify_payroll`;
        window.axios.put(url, {
            notify_payroll: this.form.notify_payroll,
            cc_email: this.cc_email,
          })
          .then((response) => {
            this.loadingNotifyNomina = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusNotifyNomina = false;
            if (this.form.notify_payroll === 0) {
              this.titleStatusNotifyNomina = 'inactivar';
              this.form.notify_payroll = 1;
              this.itemsNomina[0].value = 1;

              this.form.notify_fel = 1;
              this.items[0].value = 1;
            } else {
              this.titleStatusNotifyNomina = 'activar';
              this.form.notify_payroll = 0;
              this.itemsNomina[0].value = 0;

              this.form.notify_fel = 0;
              this.items[0].value = 0;
            }
            this.cc_email = '';
            this.$router.go(0);
          });
      },
      toggleMail() {
        this.loadingMail = true;
        const url = `/api/enterprises/${this.enterpriseId}/correo`;
        window.axios.put(url, {
            send_mail: this.form.send_mail,
          })
          .then((response) => {
            this.loadingMail = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusMail = false;
            if (this.form.send_mail === 0) {
              this.switch = false;
              this.titleStatusMail = 'inactivar';
              this.form.send_mail = 1;
              this.items[2].value = 1;
            } else {
              this.switch = true;
              this.titleStatusMail = 'activar';
              this.form.send_mail = 0;
              this.items[2].value = 0;
            }
          });
      },
      toggleSalesBook() {
        this.loadingSalesBook = true;
        const url = `/api/enterprises/${this.enterpriseId}/salesbook`;
        window.axios.put(url, {
            sales_book: this.form.sales_book,
          })
          .then((response) => {
            this.loadingSalesBook = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusSalesBook = false;
            if (this.form.sales_book === 0) {
              this.switch = false;
              this.titleStatusSalesBook = 'inactivar';
              this.form.sales_book = 1;
              this.items[3].value = 1;
            } else {
              this.switch = true;
              this.titleStatusSalesBook = 'activar';
              this.form.sales_book = 0;
              this.items[3].value = 0;
            }
          });
      },
      toggleBatches() {
        this.loadingBatches = true;
        const url = `/api/enterprises/${this.enterpriseId}/batches`;
        window.axios.put(url, {
            batches: this.form.batches,
          })
          .then((response) => {
            this.loadingBatches = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusBatches = false;
            if (this.form.batches === 0) {
              this.switch = false;
              this.titleStatusBatches = 'inactivar';
              this.form.batches = 1;
              this.items[4].value = 1;
            } else {
              this.switch = true;
              this.titleStatusBatches = 'activar';
              this.form.batches = 0;
              this.items[4].value = 0;
            }
          });
        if (this.form.batches === 1) {
          this.checkSFTPCredentials();
        }
      },
      toggleLogsError() {
        this.loadingLogs = true;
        const url = `/api/enterprises/${this.enterpriseId}/logs_error`;
        window.axios.put(url, {
          logs: this.form.logs_error,
          })
          .then((response) => {
            this.loadingLogs = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusLogs = false;
            if (this.form.logs_error === 0) {
              this.switch = false;
              this.titleStatusLogs = 'inactivar';
              this.form.logs_error = 1;
              this.items[5].value = 1;
            } else {
              this.switch = true;
              this.titleStatusLogs = 'activar';
              this.form.logs_error = 0;
              this.items[5].value = 0;
            }
          });
      },
      toggleAnnulment() {
        this.loadingAnnulment = true;
        const url = `/api/enterprises/${this.enterpriseId}/annulment`;
        window.axios.put(url, {
          annulment: this.form.annulment,
          })
          .then((response) => {
            this.loadingAnnulment = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusAnnulment = false;
            if (this.form.annulment === 0) {
              this.switch = false;
              this.titleStatusAnnulment = 'inactivar';
              this.form.annulment = 1;
              this.items[6].value = 1;
            } else {
              this.switch = true;
              this.titleStatusAnnulment = 'activar';
              this.form.annulment = 0;
              this.items[6].value = 0;
            }
          });
      },
      toggleRetention() {
        this.loadingRetention = true;
        const url = `/api/enterprises/${this.enterpriseId}/retention`;
        window.axios.put(url, {
          retention: this.form.retention,
          })
          .then((response) => {
            this.loadingRetention = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusRetention = false;
            if (this.form.retention === 0) {
              this.switch = false;
              this.titleStatusRetention = 'inactivar';
              this.form.retention = 1;
              this.items[7].value = 1;
            } else {
              this.switch = true;
              this.titleStatusRetention = 'activar';
              this.form.retention = 0;
              this.items[7].value = 0;
            }
          });
      },
      toggleReceipt() {
        this.loadingReceipt = true;
        const url = `/api/enterprises/${this.enterpriseId}/receipt`;
        window.axios.put(url, {
          receipt: this.form.receipt,
          })
          .then((response) => {
            this.loadingReceipt = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusReceipt = false;
            if (this.form.receipt === 0) {
              this.switch = false;
              this.titleStatusReceipt = 'inactivar';
              this.form.receipt = 1;
              this.items[8].value = 1;
            } else {
              this.switch = true;
              this.titleStatusReceipt = 'activar';
              this.form.receipt = 0;
              this.items[8].value = 0;
            }
          });
      },
      toggleSendSMS() {
        this.loadingSendSMS = true;
        const url = `/api/enterprises/${this.enterpriseId}/send_sms`;
        window.axios.put(url, {
          send_sms: this.form.send_sms,
          })
          .then((response) => {
            this.loadingSendSMS = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusSendSMS = false;
            if (this.form.send_sms === 0) {
              this.switch = false;
              this.titleStatusSendSMS = 'inactivar';
              this.form.send_sms = 1;
              this.items[9].value = 1;
            } else {
              this.switch = true;
              this.titleStatusSendSMS = 'activar';
              this.form.send_sms = 0;
              this.items[9].value = 0;
            }
          });
      },
      toggleAssociationTask() {
        this.loadingAssociationTask = true;
        const url = `/api/enterprises/${this.enterpriseId}/association_task`;
        window.axios.put(url, {
          association_task: this.form.association_task,
          })
          .then((response) => {
            this.loadingAssociationTask = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusAssociationTask = false;
            if (this.form.association_task === 0) {
              this.switch = false;
              this.titleStatusAssociationTask = 'inactivar';
              this.form.association_task = 1;
              this.items[10].value = 1;
            } else {
              this.switch = true;
              this.titleStatusAssociationTask = 'activar';
              this.form.association_task = 0;
              this.items[10].value = 0;
            }
          });
      },
      toggleSendOrder() {
        this.loadingSendOrder = true;
        const url = `/api/enterprises/${this.enterpriseId}/send_order`;
        window.axios.put(url, {
          send_order: this.form.send_order,
          })
          .then((response) => {
            this.loadingSendOrder = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusSendOrder = false;
            if (this.form.send_order === 0) {
              this.switch = false;
              this.titleStatusSendOrder = 'inactivar';
              this.form.send_order = 1;
              this.items[11].value = 1;
            } else {
              this.switch = true;
              this.titleStatusSendOrder = 'activar';
              this.form.send_order = 0;
              this.items[11].value = 0;
            }
          });
      },
      toggleSendWhatsApp() {
        this.loadingSendWhatsApp = true;
        const url = `/api/enterprises/${this.enterpriseId}/send_whatsapp`;
        window.axios.put(url, {
          send_whatsapp: this.form.send_whatsapp,
          })
          .then((response) => {
            this.loadingSendWhatsApp = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusSendWhatsApp = false;
            if (this.form.send_whatsapp === 0) {
              this.switch = false;
              this.titleStatusSendWhatsApp = 'inactivar';
              this.form.send_whatsapp = 1;
              this.items[12].value = 1;
            } else {
              this.switch = true;
              this.titleStatusSendWhatsApp = 'activar';
              this.form.send_whatsapp = 0;
              this.items[12].value = 0;
            }
          });
      },
      toggleCodeQR() {
        this.loadingCodeQR = true;
        const url = `/api/enterprises/${this.enterpriseId}/code_qr`;
        window.axios.put(url, {
          code_qr: this.form.code_qr,
          })
          .then((response) => {
            this.loadingCodeQR = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusCodeQR = false;
            if (this.form.code_qr === 0) {
              this.switch = false;
              this.titleStatusCodeQR = 'inactivar';
              this.form.code_qr = 1;
              this.items[13].value = 1;
            } else {
              this.switch = true;
              this.titleStatusCodeQR = 'activar';
              this.form.code_qr = 0;
              this.items[13].value = 0;
            }
          });
      },
      togglePayment() {
        this.loadingPayment = true;
        const url = `/api/enterprises/${this.enterpriseId}/payment`;
        window.axios.put(url, {
          payment: this.form.payment,
          })
          .then((response) => {
            this.loadingPayment = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusPayment = false;
            if (this.form.payment === 0) {
              this.switch = false;
              this.titleStatusPayment = 'inactivar';
              this.form.payment = 1;
              this.items[14].value = 1;
            } else {
              this.switch = true;
              this.titleStatusPayment = 'activar';
              this.form.payment = 0;
              this.items[14].value = 0;
            }
          });
      },
      toggleOnlyIGTF() {
        this.loadingOnlyIGTF = true;
        const url = `/api/enterprises/${this.enterpriseId}/onlyigtf`;
        window.axios.put(url, {
          only_IGTF: this.form.only_IGTF,
          })
          .then((response) => {
            this.loadingOnlyIGTF = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusOnlyIGTF = false;
            if (this.form.only_IGTF === 0) {
              this.switch = false;
              this.titleStatusOnlyIGTF = 'inactivar';
              this.form.only_IGTF = 1;
              this.items[15].value = 1;
            } else {
              this.switch = true;
              this.titleStatusOnlyIGTF = 'activar';
              this.form.only_IGTF = 0;
              this.items[15].value = 0;
            }
          });
      },
      toggleLVNegative() {
        this.loadingLVNegative = true;
        const url = `/api/enterprises/${this.enterpriseId}/lvnegative`;
        window.axios.put(url, {
          lv_negative: this.form.lv_negative,
          })
          .then((response) => {
            this.loadingLVNegative = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusLVNegative = false;
            if (this.form.lv_negative === 0) {
              this.switch = false;
              this.titleStatusLVNegative = 'inactivar';
              this.form.lv_negative = 1;
              this.items[16].value = 1;
            } else {
              this.switch = true;
              this.titleStatusLVNegative = 'activar';
              this.form.lv_negative = 0;
              this.items[16].value = 0;
            }
          });
      },
      toggleWebPayroll() {
        this.loadingWebPayroll = true;
        const url = `/api/enterprises/${this.enterpriseId}/web_payroll`;
        window.axios.put(url, {
          web_payroll: this.form.web_payroll,
          })
          .then((response) => {
            this.loadingWebPayroll = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusWebPayroll = false;
            if (this.form.web_payroll === 0) {
              this.switch = false;
              this.titleStatusWebPayroll = 'inactivar';
              this.form.web_payroll = 1;
              this.itemsNomina[1].value = 1;
            } else {
              this.switch = true;
              this.titleStatusWebPayroll = 'activar';
              this.form.web_payroll = 0;
              this.itemsNomina[1].value = 0;
            }
          });
      },
      toggleCustomer() {
        this.loadingCustomer = true;
        const url = `/api/enterprises/${this.enterpriseId}/customer`;
        window.axios.put(url, {
          customer_portal: this.form.customer_portal,
          })
          .then((response) => {
            this.loadingCustomer = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusCustomer = false;
            if (this.form.customer_portal === 0) {
              this.switch = false;
              this.titleStatusCustomer = 'inactivar';
              this.form.customer_portal = 1;
              this.items[17].value = 1;
            } else {
              this.switch = true;
              this.titleStatusCustomer = 'activar';
              this.form.customer_portal = 0;
              this.items[17].value = 0;
            }
          });
      },
      toggleExternalPdf() {
        this.loadingExternalPdf = true;
        const url = `/api/enterprises/${this.enterpriseId}/externalPdf`;
        window.axios.put(url, {
          external_pdf: this.form.external_pdf,
          })
          .then((response) => {
            this.loadingExternalPdf = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusExternalPdf = false;
            if (this.form.external_pdf === 0) {
              this.switch = false;
              this.titleStatusExternalPdf = 'inactivar';
              this.form.external_pdf = 1;
              this.items[18].value = 1;
            } else {
              this.switch = true;
              this.titleStatusExternalPdf = 'activar';
              this.form.external_pdf = 0;
              this.items[18].value = 0;
            }
          });
      },
      toggleOtherCurrency() {
        this.loadingOtherCurrency = true;
        const url = `/api/enterprises/${this.enterpriseId}/othercurrency`;
        window.axios.put(url, {
          other_currency: this.form.other_currency,
          })
          .then((response) => {
            this.loadingOtherCurrency = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusOtherCurrency = false;
            if (this.form.other_currency === 0) {
              this.switch = false;
              this.titleStatusOtherCurrency = 'inactivar';
              this.form.other_currency = 1;
              this.items[19].value = 1;
            } else {
              this.switch = true;
              this.titleStatusOtherCurrency = 'activar';
              this.form.other_currency = 0;
              this.items[19].value = 0;
            }
          });
      },
      toggleFiscalValidation() {
        this.loadingFiscalValidation = true;
        const url = `/api/enterprises/${this.enterpriseId}/fiscalvalidation`;
        window.axios.put(url, {
          fiscal_validation: this.form.fiscal_validation,
          })
          .then((response) => {
            this.loadingFiscalValidation = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusFiscalValidation = false;
            if (this.form.fiscal_validation === 0) {
              this.switch = false;
              this.titleStatusFiscalValidation = 'inactivar';
              this.form.fiscal_validation = 1;
              this.items[20].value = 1;
            } else {
              this.switch = true;
              this.titleStatusFiscalValidation = 'activar';
              this.form.fiscal_validation = 0;
              this.items[20].value = 0;
            }
          });
      },
      togglePaymentQuote() {
        this.loadingPaymentQuote = true;
        const url = `/api/enterprises/${this.enterpriseId}/paymentquote`;
        window.axios.put(url, {
          payment_quote: this.form.payment_quote,
          })
          .then((response) => {
            this.loadingPaymentQuote = false;
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
            this.dialogStatusPaymentQuote = false;
            if (this.form.payment_quote === 0) {
              this.switch = false;
              this.titleStatusPaymentQuote = 'inactivar';
              this.form.payment_quote = 1;
              this.items[21].value = 1;
            } else {
              this.switch = true;
              this.titleStatusPaymentQuote = 'activar';
              this.form.payment_quote = 0;
              this.items[21].value = 0;
            }
          });
      },
      getProvincia() {
        const url = '/api/provinces';
        return window.axios.get(url);
      },
      getDistrito() {
        if (this.form.cat_province_id) {
            const url = `/api/districts/${this.form.cat_province_id}`;
            window.axios.get(url)
            .then((response) => {
            this.itemsDistrict = response.data;
          });
        }
      },
      getCorregimiento() {
        if (this.form.cat_district_id) {
            const url = `/api/corregimientos/${this.form.cat_district_id}`;
            window.axios.get(url)
            .then((response) => {
            this.itemsMunicipality = response.data;
          });
        }
      },
      updateActivities(activities) {
        this.form.activities_code = [];
        if (activities !== null) {
          activities.forEach((item) => {
            this.form.activities_code.push(item);
          });
        }
      },
      async checkSFTPCredentials() {
        const url = `/api/enterprises/${this.enterpriseId}/sftp/get`;
        window.axios.get(url)
        .then((result) => {
          if (result.data.code === 500) {
            this.form.folder = result.data.folder;
          } else {
            this.form.folder = result.data.folder;
          }
        });
      },
     /*  getSeller() {
        const url = 'api/catalogs/sellers/getSeller';
        return window.axios.get(url);
      }, */
      getSeller() {
      /* const url = 'api/catalogs/sellers/getSeller';
         window.axios.get(url)
         .then((response) => {
          if (response.data.code === 200) {
            const rawSellers = response.data.sellers;
            this.itemsSeller = rawSellers.map((seller) => seller);
          } else {
            this.itemsSeller = [];
          }
        }); */
        const url = 'api/catalogs/sellers/getSeller';
        return window.axios.get(url);
      },
      selectProvider() {
        if (this.form.whatsapp_provider === 1) {
          this.form.send_file_whatsapp = 1;
        }
      },
    },
  };

</script>
